import { render, staticRenderFns } from "./software-detail.vue?vue&type=template&id=4b2cdb70&scoped=true&"
import script from "./software-detail.vue?vue&type=script&lang=js&"
export * from "./software-detail.vue?vue&type=script&lang=js&"
import style0 from "./software-detail.vue?vue&type=style&index=0&id=4b2cdb70&prod&lang=scss&"
import style1 from "./software-detail.vue?vue&type=style&index=1&id=4b2cdb70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2cdb70",
  null
  
)

export default component.exports